<template>
  <div>
    <b-row>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/markeranalytic120\iconA120\analytic120 1.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">ปริมาณยานพาหนะทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ total }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              คัน/วัน
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/markeranalytic120\iconA120\analytic120 2.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">ยานพาหนะสูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="font-size: 24px; color: #F9E6BE;">{{ Type }} </span>
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ TypeMax }}
            </span>
            <span
              style="position: relative; text-align:center; font-weight: 600; font-size:20px;"
            >
              คัน/วัน
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <!-- ---------------total location----------- -->
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/markeranalytic120\iconA120\analytic120 3.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">รถบรรทุกเลนขวา</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ truckRightlen }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              คัน
            </span>
          </foreignObject>
          <foreignObject
            x="220"
            y="70"
            width="300"
            height="150"
            color="#ffffff"
          >
            <b-card-header>
              <b-button
                id="toggle-btn"
                v-b-modal="'modalRightLaneTruck'"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                style="font-size: 14px;"
                title="Click to show more"
              >
                <span
                  class="align-middle"
                  style="color: #11DF00;"
                >
                  ดูเพิ่มเติม
                  <feather-icon
                    icon="ChevronsRightIcon"
                    size="16"
                  />
                </span>
              </b-button>
            </b-card-header>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="6"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/markeranalytic120\iconA120\analytic120 4.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
            color="#ffffff"
          >
            <div>
              <span style="font-weight: 600; font-size:20px">รถขับเร็ว/ช้าเลนขวา</span>
            </div>
          </foreignObject>
          <foreignObject
            x="30"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ Right_len }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              คัน
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
    </b-row>
    <ModalRightLaneTruck />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BButton, BCardHeader,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import ModalRightLaneTruck from '@/views/analytic120/modalAnalytic/ModalRightLaneTruck.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BButton,
    BCardHeader,
    ModalRightLaneTruck,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      total: '',
      TypeMax: '',
      Type: '',
      truckRightlen: '',
      WrongWay: '',
      Right_len: '',
      totalLocation: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getTotalAI()
    this.getTotalAI1()
    this.interval = setInterval(() => {
      this.getTotalAI()
      this.getTotalAI1()
    }, 300000)
  },
  methods: {
    getTotalAI() {
      axios
        .post('/getStaticTotalAI', { department: this.userData.department })
        .then(response => {
          this.total = response.data[10].countNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.TypeMax = response.data[5].countNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          if (response.data[5].countNum === response.data[1].countNum && response.data[5].countNum !== 0) {
            this.Type = 'จักรยานยนต์'
          } else if (response.data[5].countNum === response.data[3].countNum && response.data[5].countNum !== 0) {
            this.Type = 'รถยนต์'
          } else if (response.data[5].countNum === response.data[12].countNum && response.data[5].countNum !== 0) {
            this.Type = 'รถบรรทุก'
          } else if (response.data[5].countNum === response.data[2].countNum && response.data[5].countNum !== 0) {
            this.Type = 'รถบัส'
          } else if (response.data[5].countNum === response.data[9].countNum && response.data[5].countNum !== 0) {
            this.Type = 'รถแท็กซี่'
          } else if (response.data[5].countNum === response.data[6].countNum && response.data[5].countNum !== 0) {
            this.Type = 'รถกระบะ'
          } else if (response.data[5].countNum === response.data[11].countNum && response.data[5].countNum !== 0) {
            this.Type = 'รถพ่วง'
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTotalAI1() {
      axios
        .post('/getSumCountTotal', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.truckRightlen = response.data[4][0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Right_len = (response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
